export default {
  LIGHT: 'light',
  DARK: 'dark',
};
